const LOCALES = {
    sv: 'sv_SE',
    en: 'en_GB',
    de: 'de_DE',
    da: 'da_DK',
    fr: 'fr_FR',
    nl: 'nl_NL'
};

export const getLoginLocaleFromLanguage = (language) =>
    language in LOCALES ? LOCALES[language] : null;
